<div class="card" [ngClass]="{ 'cursor-pointer': !disabled, disabled: disabled }" (click)="click()">
  <div class="text-center p-4 border-end">
    <div class="mx-auto mb-4">
      <i class="fas fa-4x" [ngClass]="icon"></i>
    </div>
    <h5 class="text-truncate pb-1">{{ text }}</h5>
  </div>
</div>
